import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; 
import LoginForm from "./components/loginform";
import AutoLoginForm from "./components/AutoLogin";
import HomeForm from "./components/HomeForm";
import "./App.css";
import ClassLink from "./components/ClassLink";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState({ preventBack: true }, "", window.location.pathname);
    window.history.pushState({ preventBack: true }, "", window.location.pathname);

    const handleBackButton = (event) => {
      event.preventDefault();

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-dialog">
              <div className="custom-dialog-header">
                <span>Confirm Log Out</span>
              </div>
              <div className="custom-dialog-body">
                <p>Are you sure you want to go back? You may be logged out.</p>
              </div>
              <div className="custom-dialog-footer">
              <button className="custom-confirm-button" onClick={() => {
                  navigate("/");
                  onClose();
                }}>
                  Yes, Go Back
                </button>
                <button className="custom-cancel-button" onClick={() => {
                  onClose();
                  window.history.pushState({ preventBack: true }, "", location.pathname);
                }}>
                  Cancel
                </button>
              </div>
            </div>
          );
        }
      });
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [location, navigate]);

  return (
    <Routes>
      <Route path="/" element={<LoginForm />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/autologin" element={<AutoLoginForm />} />
      <Route path="/classlink" element={<ClassLink />} />
      <Route path="/HomeForm" element={<HomeForm />} />
    </Routes>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;